import { ThemeProvider as ThemeProviderMui } from '@mui/material/styles'
import React from 'react'
import { Provider } from 'react-redux'
import { ThemeProvider } from './context/ThemeProvider'
import { store } from './redux/store'
import Routes from './routes'
import { theme } from './theme/theme'



export default function App() {
  return (
    <ThemeProviderMui theme={theme}>
      <ThemeProvider>
        <Provider store={store}>
          <Routes />
        </Provider>
      </ThemeProvider>
    </ThemeProviderMui>
  )
}
